import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography } from 'antd';
import { ProjectDto } from '@/core';
import { sort } from '@/utils';
import { ProjectsRolesCard } from './RolesAndRatesCard';
import classes from './ProjectsRolesCardsList.module.scss';

type ProjectsRolesListProps = {
  projectData: ProjectDto;
};

export const ProjectsRolesList = ({ projectData }: ProjectsRolesListProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [editedCardsIds, setEditedCardsIds] = useState<string[]>([]);
  const positionsSortedAlphabetically = [...projectData.positions].sort((a, b) => sort(a.name, b.name));

  const handleClickEdit = (id: string) => setEditedCardsIds((prev) => [...prev, id]);
  const handleStopEditRoleCard = (id: string) =>
    setEditedCardsIds((prev) => prev.filter((editedCardId) => editedCardId !== id));

  return (
    <div className={classes.rolesList}>
      <Row className={classes.rolesListTitle}>
        <Col span={12}>
          <Typography.Text>{t('addRoles.roles')}</Typography.Text>
        </Col>
        <Col span={12}>
          <Typography.Text>{t('addRoles.rates')}</Typography.Text>
        </Col>
      </Row>
      {positionsSortedAlphabetically.map((position) => (
        <ProjectsRolesCard
          key={position.id}
          onClickMenuEdit={() => handleClickEdit(position.id)}
          isEdit={editedCardsIds.includes(position.id)}
          stopEditRoleCard={() => handleStopEditRoleCard(position.id)}
          projectData={projectData}
          {...position}
        />
      ))}
    </div>
  );
};
